type SentryModule = typeof import("@sentry/vue");

let _sentry: SentryModule | null = null;

export async function initSentry(
  app: unknown,
  options: Record<string, unknown>
): Promise<void> {
  if (window.location.hostname === "localhost") return;
  const Sentry = await import("@sentry/vue");
  _sentry = Sentry;
  Sentry.init({
    app: app as never,
    ...options,
    integrations: [
      new Sentry.BrowserTracing({
        tracingOrigins: ["yomumo.net", "https://book-card-dev.web.app/", /^\//],
      }),
      new Sentry.Replay(),
    ],
  } as never);
}

export function setUser(user: { id?: string; username?: string }): void {
  _sentry?.setUser(user);
}

export function setContext(
  name: string,
  context: Record<string, unknown>
): void {
  _sentry?.setContext(name, context);
}

export function withScope(
  callback: (scope: { setLevel: (level: string) => void }) => void
): void {
  _sentry?.withScope(callback as never);
}

export function captureException(error: unknown): void {
  _sentry?.captureException(error);
}

export function showReportDialog(options?: Record<string, unknown>): void {
  _sentry?.showReportDialog(options as never);
}
